

export enum AssessmentQuestionType {
  Objective = 1,
  Other = 2,
  None = 3,
  Yes = 4,
  No = 5,
}